import {
    useAuthStore,
    useModalsStore,
} from '@frontend/stores'
import {Modal} from 'swayok-react-mdb-ui-kit/components/Modal/Modal'
import {ModalBody} from 'swayok-react-mdb-ui-kit/components/Modal/ModalBody'
import {ModalContent} from 'swayok-react-mdb-ui-kit/components/Modal/ModalContent'
import {ModalHeaderCloseButton} from 'swayok-react-mdb-ui-kit/components/Modal/ModalHeaderCloseButton'
import {LoginForm} from './LoginForm'

// Окно авторизации
export function LoginModal() {

    const loginModalVisible = useModalsStore(
        state => state.loginModalVisible
    )
    const hideLoginModal = useModalsStore(
        state => state.hideLoginModal
    )
    const cancelUserAuth = useAuthStore(
        state => state.cancelUserAuth
    )

    return (
        <Modal
            show={loginModalVisible}
            size="sm"
            staticBackdrop
            depth={3}
            dialogId="login-modal"
            onClosed={() => hideLoginModal(true)}
            render={() => (
                <ModalContent>
                    <ModalHeaderCloseButton
                        floating
                        onClose={() => cancelUserAuth()}
                        className="mt-2 me-2"
                    />
                    <ModalBody className="p-0">
                        <LoginForm inModal />
                    </ModalBody>
                </ModalContent>
            )}
        />
    )
}
